export default {
  registration: {
    name: "Nombre",
    institution: "Establecimiento",
    component: "Componente",
    trainingCourse: "Promoción",
    group: "Grupo",
    Contact: "Contacto",
    registration_settings: "Configuración de inscripción",
    pedagogicInformations: "Información educativa",
    fundingInformations: "Información financiera",
    dates: "Fechas",
    from_to: "de {from} al {to}",
    hourlyVolume: "Volumen horario",
    hourlyRemoteVolume: ({ named }) => `De los cuales ${named("volume")} h a distancia`,
    modality: ({ plural }) => plural(["Modalidad", "Modalidades"]),
    in_person: "Presencial",
    distanciel: "A distancia",
    remoteVolume: "Incluida la enseñanza a distancia",
    degreePrepared: "Diploma preparado",
    level: "Nivel",
    titleRncp: "Cualificación RNCP",
    degreeCode: "Código del diploma",
    calendar: "Calendario",
    program: "Programa",
    apprenticeShipContract: "Contrato de aprendizaje",
    proContract: "Contrato de profesionalización",
    rate: "Tarifa",
    publicAnnualRate: "Coste anual para los empleadores del sector público",
    annualRate: "Coste anual",
    totalRate: "Coste total",
    hourlyRate: "Precio por hora",
    followUp: "Seguimiento",
    devices: "Dispositivos",
    createdAt: "crea el {date}",
    help: "Ayuda",
    follow: "Seguimiento",
    inProgress: "En curso",
    validatedAt: "Validado el {date} pro {validator}",
    steps: "Las etapas",
    statistics: "Estadísticas",
    pending: "En cours",
    publicSector: "Sector público",
    privateSector: "Secteur privado",
    link_copied_success: "¡Enlace copiado correctamente al portapapeles!",
    head_office: "Sede social",
    status: {
      upcoming: "Próximamente ",
      in_progress: "En curso",
      finalised: "Finalisé",
      break_up: "Ruptura",
      cancelled: "Cancelado",
    },
    insee_company: {
      title: ({ plural }) => plural(["Empresa INSEE ", "Empresas INSEE"]),
      siret: "SIRET",
      activity: "Actividad (NAF/APE)",
      details: "Detalles (nombre, enseña, dirección)",
      creation: "Creación",
      state: "Estado",
      social_reason: "Razón social",
      current: "Establecimiento habitual",
      head_office: "Sede de la empresa",
      creation_date: "Fecha de creación",
      work_force: "Plantilla",
      status: "Estatuto",
      principal_address: "Dirección principal",
      secondary_address: "Dirección secundaria",
      empty_contact: "No hay ningún contacto registrado para esta empresa",
    },
    training_info: {
      search_by_branch: "Buscar por convenio colectivo",
      funding_coverage: "Cobertura de financiación:",
      decree_cost: "Costo decreto:",
      only_different_cost_displayed: "Por defecto, solo se muestran los costos distintos del costo decreto",
      info_tab: {
        general_info: "Información general",
        rncp_sheet: "Ficha RNCP",
        program: "Programa",
        setttings: "Configuración de inscripción",
        settings: "Configuración de inscripción",
        npec: "NPEC",
        contact: "contacto para las empresas",
      },
      general_info: {
        institution_name: "Nombre de la institución",
        reference: "Referencia",
        rncp_number: "Número RNCP",
        offical_name: "Nombre oficial",
        diplome_type: "Tipo de diploma",
        mention: "Nombre / mención",
        route: "Itinerario",
        diplome_code: "Código del diploma",
        status: "Estado",
        logo: "Logo",
        partner_website_url: "URL del sitio del socio",
        link: "Enlace",
        work_study_duration: "Duración de la formación en alternancia",
        total_cycle_time: "Duración total del ciclo",
        active: "Activa",
        archived: "Archivada",
      },
    },
    alert: {
      title: ({ plural }) => plural(["Alerta ", "Alertas"]),
      level: {
        info: "Información",
        warning: "Alerta",
        error: "Error",
      },
      active_unactive: "Activar/Desactivar",
      empty: "No hay alertas de nivel {level}",
    },
    group_action: {
      see_sheet: "Ver la ficha de preinscripción",
      copy_sheet: "Copiar el enlace de la ficha de preinscripción",
      create: "Crear una ficha de preinscripción",
      see_group_detail: "Ver detalles del grupo",
      delete: {
        confirmation: "¿Estás seguro de que quieres eliminar este grupo?",
        success: "¡Grupo eliminado correctamente!",
      },
    },
    dashboard: {
      go_to: "Acceder al panel de esta formación",
    },
    creation: {
      info: "Para crear una nueva ficha de inscripción, introduzca primero la información del candidato",
      success: ({ named }) =>
        `¡El formulario de preinscripción para ${named("firstName")} ${named("lastName")} se ha creado correctamente!`,
    },
    user_not_connected: "Debe iniciar sesión para acceder a este espacio.",
    quote: {
      contract: "Contrato",
      financial: "Financiación",
      amount: "Cuadrícula de importes",
      edit_cost: "Modificar los costos",
      subtitle: "Resumen financiero del contrato de aprendizaje",
      initial_cost: "Costo inicial",
      final_cost: "Costo final",
      modal_alert:
        "Estos cambios afectarán el importe facturado a la empresa. Asegúrese de que los importes cumplen con su convenio.",
      discount: ({ named }) => `Descuento comercial: ${named("economy")} (${named("discount")})`,
      edit: {
        date: {
          title: "Modificar las fechas del contrato",
          success: "¡Modificación de las fechas del contrato realizada con éxito!",
        },
        cost: {
          title: "Modificar los importes",
          success: "¡Importes modificados con éxito!",
        },
      },
      table: {
        columns: {
          trainingCourseCost: "Costo de la formación",
          opcoo: "Asistencia",
          mandatory_participation: "Contribución obligatoria",
          remaining_cost: "Costo restante",
        },
      },
      duration: {
        title: "Duración",
      },
      startDate: {
        title: "Fecha de inicio",
      },
      endDate: {
        title: "Fecha de fin",
      },
    },
    contact: {
      title: "Un contacto",
      success: "¡Contacto añadido con éxito!",
      delete: {
        confirmation: "¿Está seguro de que desea eliminar este contacto?",
        success: "¡Contacto eliminado con éxito!",
      },
    },
    contractType: {
      apprentice: "Aprendices",
      pro: "Contrato de profesionalización",
    },
    document: {
      baseline: "Documento para imprimir, firmar e importar a continuación",
      cerfa: {
        title: "CERFA",
      },
      convention: {
        title: "Convención",
      },
      update: {
        success: ({ named }) => `¡Tu ${named("document")} se ha guardado correctamente!`,
      },
    },
    step: {
      validation: {
        success: "¡Etapa completada con éxito!",
      },
    },
    save: {
      success: "¡Su formulario de inscripción se ha registrado correctamente!",
    },
    create: {
      confirmation: "¿Está seguro de que desea crear una nueva ficha de preinscripción?",
    },
    contract: {
      empty: "Ningún contrato disponible",
      see: "Acceder al contrato",
    },
    empty_registation_list: "Ninguna ficha de preinscripción disponible",
    empty_document: "Ningún documento",
    company_dashboard: {
      following_contract: {
        title: "Lista de contratos",
      },
    },
    contract_status: {
      init: "Inicializada",
      to_send_to_training_center: "Para enviar",
      sent_to_training_center: "Enviada",
      validated_training_center: "Validado",
      signed: "Firmado",
      error: "Error",
      archived: "Archivado",
    },
    years: "años",
    workInProgress: "Trabajo en progreso",
    valid: "Validar",
    uaiCode: "Código UAI",
    tutor: "Tutor",
    training: "Entrenamiento",
    totalWorkForce: "Mano de obra total",
    socialReason: "Razón social",
    signIn: "Crear cuenta",
    see_more: "Ver más",
    pricePolicyInfo3: "La tarifa se alinea con la cobertura.",
    pricePolicyInfo2:
      "Cargo restante solo si la cobertura es inferior a la tarifa; si es superior, se aplica la tarifa según la cobertura.",
    pricePolicyInfo1:
      "Cargo restante solo si la cobertura es menor; cobertura limitada a la tarifa, incluso si es superior.",
    previousSituation: "Situación anterior",
    prev: "Anterior",
    preContractSituation: "Situación previa al contrato",
    phone: "Teléfono",
    opco: "OPCO",
    noNeedAccount: "Ya tengo una cuenta",
    next: "Siguiente",
    needAccount: "No tengo una cuenta",
    nationality: "Nacionalidad",
    map: "Supervisor de aprendizaje",
    male: "Sr.",
    loginInfo2: "Inicie sesión para acceder al formulario de registro",
    loginInfo: "Inicie sesión o cree una cuenta para acceder al formulario de registro",
    login: "Iniciar sesión",
    lastInstitution: "Última institución",
    lastDegreePrepared: "Último título preparado",
    lastDegreeObtained: "Último título obtenido",
    ineCode: "Código INE",
    idcc: "IDCC",
    iAm: "Soy",
    hourlyTrainingVolume: "Número de horas",
    hostCompanyContact: "Contacto de empresa anfitriona",
    hostCompany: "Empresa anfitriona",
    generalInformations: "Información general",
    function: "Función",
    firstName: "Nombre",
    female: "Sra.",
    employerType: "Tipo de empleador",
    employerSubType: "Subtipo de empleador",
    email: "Correo electrónico",
    download_training_sheet: "Descargar hoja de capacitación",
    department: "Departamento",
    degree: "Título",
    createCompanyAccount: "Crear cuenta de empresa",
    createApprenticeAccount: "Crear cuenta de aprendiz",
    contacts: "Contactos",
    company: "Empresa",
    civility: "Cortesía",
    birthDate: "Fecha de nacimiento",
    apprenticeMaster2: "Supervisor de aprendices 2",
    apprenticeMaster: "Supervisor de aprendices",
    anApprentice: "Un aprendiz",
    age: "Edad",
    administratorCompanyContact: "Contacto de sede empresa",
    administratorCompany: "Sede de la empresa",
    address: "Dirección",
    activityCode: "Código de actividad (NAF)",
    accountExistSubTitle: "con la dirección de correo proporcionada. Por favor inicie sesión.",
    accountExist: "Ya existe una cuenta",
    aCompany: "Una empresa",
    endDate: "Fecha de fin",
    startDate: "Fecha de inicio",
  },
};
